<template>
  <div>
    <select v-if="app" ref="web" v-model="current" class="fallback">
      <option v-for="item in options" :value="item" v-bind:key="item.id">
        {{ item[label] }}
      </option>
    </select>

    <div v-click-outside="close">
      <div class="selector" @click="toggle" v-if="value">
        <icon :name="prefix + value.icon.replace('socicon-', '').replace('vkontakte', 'vk')" style="margin-right: 5px" scale="1.8"></icon>

        {{ value.is_hidden && !sub ? options.find(item => item.is_comments)[label] : value[label] }}

        <icon :name="open ? 'angle-up' : 'angle-down'" class="pull-right" scale="1.8"></icon>
      </div>
      <transition name="list">
        <ul v-show="open" class="dropdown-menu" style="display: block;">
          <li v-for="item in options" :class="{ active: item.id === value.id }" v-bind:key="item.id">
            <span @click="change(item);" :data-name="item.name.toLowerCase()" :id="item.id">
              <icon :name="prefix + item.icon.replace('socicon-', '').replace('vkontakte', 'vk')"></icon> {{ item[label] }}
            </span>
          </li>
        </ul>
      </transition>
    </div>
  </div>
</template>

<script>
import ClickOutside from 'vue-click-outside'

export default {
  name: 'Selector',
  directives: {
    ClickOutside
  },
  props: {
    value: {
      type: Object
    },
    sub: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: 'name',
    },
    prefix: {
      type: String,
      default: '',
    },
    options: {
      type: Array,
      required: true,
    },
    app: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      open: false,
      current: {}
    }
  },
  watch: {
    current(item) {
      this.change(item)
    },
  },
  methods: {
    close() {
      this.open = false
    },
    toggle() {
      this.open = !this.open
    },
    change(item) {
      this.$emit('input', item)
      this.close()
    }
  },
}
</script>

<style scoped>

.fallback {
  font-size: 18px;
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 1000;
  opacity: 0;
}

.dropdown-menu, .selector {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.dropdown-menu {
  width: 100%;
  margin-top: 5px;
}

.dropdown-menu svg {
  width: 20px;
}

.selector {
  cursor: pointer;
  padding: 0 10px 0 10px;
  color: #485291;
  font-size: 14px;
  line-height: 52px;
}

.selector .pull-right {
  margin-top: 12px;
}

</style>